/*
  KMS
 */

export const getKMSBaseUrl = (): string => {
  const baseurl = window.location.origin;

  if (baseurl === 'http://kmsv2:4001') return 'http://automation-test:3000';

  if (baseurl === 'http://localhost:4001') return 'http://localhost:3000';

  if (baseurl.includes('staging')) {
    const matchData = /staging\.kmsv2-(\w+)\.keywee\.sh/.exec(baseurl);
    const name = matchData![1];

    return `http://staging.kms-${name}.keywee.sh`;
  }

  return 'https://app.keywee.co';
};

export const kmsUrl = (path?: string): string => {
  const host = getKMSBaseUrl();
  if (!path) return host;

  return path[0] === '/' ? `${host}${path}` : `${host}/${path}`;
};

export const kssUrl = (path?: string): string => {
  const host = getKSSBaseUrl();
  if (!path) return host;

  return path[0] === '/' ? `${host}${path}` : `${host}/${path}`;
};

export const editFacebookCampaignUrl = (campaignId: string | number): string =>
  `/campaigns/facebook/${campaignId}/edit`;
export const editGoogleCampaignUrl = (campaignId: string | number): string => `/campaigns/google/${campaignId}/edit`;

export const duplicateCampaignUrl = (campaignId: string | number): string =>
  `/campaigns/facebook/${campaignId}/duplicate`;

export const downloadHugoTemplateUrl = (campaignId: string | number, startDate: string, endDate: string): string =>
  kmsUrl(`/hugo/export?campaign_id=${campaignId}&start_date=${startDate}&end_date=${endDate}`);

export const editArticlePageUrl = (articleId: string | number): string => `/articles/${articleId}/edit`;

/*
  KSS UI
 */

export const kssStory = (publisherId: string | number, articleId: string | number): string => {
  return kssUrl(`/aud_dev/reports/stories/${articleId}?publisher=${publisherId}`);
};

export const articlePageUrl = (articleId: string | number): string => {
  return `/articles/${articleId}`;
};

export const articleGroupUrl = (articleGroupId: string | number, tab: string | null): string => {
  return `/article_groups/${articleGroupId}/${tab}`;
};

export const articleStories = (campaignId: string | number): string => {
  return `/insights?attributionWindow=default&tab=articles&campaignIds=${campaignId}`;
};

/*
  KSS
 */

export const getKSSBaseUrl = (): string => {
  const baseurl = window.location.origin;

  if (baseurl === 'http://localhost:4001') {
    return 'http://localhost:4000';
  }

  if (baseurl === 'http://kmsv2') {
    return 'http://kssv2';
  }

  if (baseurl.includes('staging')) {
    const name = /-(\w+)\./.exec(baseurl);
    return `http://staging.kssv2-${name?.[1] ?? ''}.keywee.sh`;
  }

  return 'https://dashboard.keywee.co';
};

/*
  Google Ads Manager
 */

export const googleAdsCampaignsUrl = (): string => {
  const baseurl = window.location.origin;

  if (baseurl === 'http://localhost:4001' || baseurl.includes('staging'))
    return 'https://ads.google.com/aw/campaigns?ocid=1116325854&campaignId=';

  return 'https://ads.google.com/aw/campaigns?ocid=1107566316&campaignId=';
};

export const googleAdsAdGroupsUrl = (): string => {
  const baseurl = window.location.origin;

  if (baseurl === 'http://localhost:4001' || baseurl.includes('staging'))
    return 'https://ads.google.com/aw/adgroups?ocid=1116325854&campaignId=';

  return 'https://ads.google.com/aw/adgroups?ocid=1107566316&campaignId=';
};

export const googleAdsAdsUrl = (): string => {
  const baseurl = window.location.origin;

  if (baseurl === 'http://localhost:4001' || baseurl.includes('staging'))
    return 'https://ads.google.com/aw/ads?ocid=1116325854&campaignId=';

  return 'https://ads.google.com/aw/ads?ocid=1107566316&campaignId=';
};
